var map = {
	"./adoNet.svg": "7162",
	"./android.svg": "16f6",
	"./angular.svg": "375f",
	"./angularJs.svg": "ce14",
	"./arrays.svg": "c98c",
	"./aspNet.svg": "0c1b",
	"./aspNetMvc.svg": "dba8",
	"./aspNetWebApi.svg": "aa2c",
	"./availabilty&Reliability.svg": "5df3",
	"./backtracking.svg": "be3f",
	"./bigONotation.svg": "26f4",
	"./bitManipulation.svg": "c0ea",
	"./blockchain.svg": "2eb7",
	"./c.svg": "6dd3",
	"./cSharp.svg": "23f3",
	"./caching.svg": "8a2b",
	"./concurrency.svg": "2a9f",
	"./css.svg": "adbd",
	"./dataStructures.svg": "d091",
	"./databases.svg": "60a0",
	"./devOps.svg": "e3a4",
	"./divide&Conquer.svg": "2603",
	"./docker.svg": "e670",
	"./dotNet.svg": "9966",
	"./dynamicProgramming.svg": "a925",
	"./entityFramework.svg": "6efb",
	"./flutter.svg": "e2db",
	"./git.svg": "2bcc",
	"./golang.svg": "a1fc",
	"./graphQl.svg": "4fc6",
	"./graphTheory.svg": "232c",
	"./greedyAlgorithms.svg": "f779",
	"./haskell.svg": "53fb",
	"./heapsAndMaps.svg": "1f42",
	"./html5.svg": "0a78",
	"./ionic.svg": "c323",
	"./jQuery.svg": "9577",
	"./java.svg": "0629",
	"./javascript.svg": "9984",
	"./kotlin.svg": "7cbe",
	"./laravel.svg": "d51a",
	"./layering&Middleware.svg": "706b",
	"./linkedLists.svg": "d695",
	"./linq.svg": "96eb",
	"./logo_white.svg": "2165",
	"./microservices.svg": "c5cb",
	"./mongoDb.svg": "c49f",
	"./netCore.svg": "ab6a",
	"./noSql.svg": "5204",
	"./nodeJs.svg": "c1c6",
	"./php.svg": "7b33",
	"./pwa.svg": "1656",
	"./python.svg": "fe30",
	"./queues.svg": "27e4",
	"./react.svg": "690b",
	"./reactNative.svg": "5aa2",
	"./reactiveProgramming.svg": "f8af",
	"./reactiveSystems.svg": "a431",
	"./recursion.svg": "cb2c",
	"./redis.svg": "7dcb",
	"./redux.svg": "3111",
	"./ruby.svg": "4bdf",
	"./rubyOnRails.svg": "4cf6",
	"./searching.svg": "0a72",
	"./soa.svg": "5ce4",
	"./sorting.svg": "b41f",
	"./spring.svg": "fa6c",
	"./sql.svg": "fb1d",
	"./stacks.svg": "597e",
	"./strings.svg": "7366",
	"./tSql.svg": "bc72",
	"./testing.svg": "04f2",
	"./trie.svg": "eb8f",
	"./typescript.svg": "d25e",
	"./uxDesign.svg": "32ba",
	"./vue.svg": "5911",
	"./wcf.svg": "5673",
	"./webSecurity.svg": "9548",
	"./websockets.svg": "5c61",
	"./xamarin.svg": "9af6"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6779";